/*
 * @Description: 知识库api
 * @Author: ljrong
 * @Date: 2024-03-16 14:38:36
 * @LastEditors: ljrong
 * @LastEditTime: 2024-04-09 09:23:14
 */
import { get, post } from '@/utils/request'

import type { EnterpriseListModel } from '@/types/enterprise'
import type {
    LibStatusItem,
    GenericKnowledgeBaseItem,
    KnowlegeSelectorParams,
    KnowlegeSelectorModel,
    LibPathItem
} from '../types/lib'


/**
 * 空间下知识库概要 - 列出空间下各个知识库有多少个文件
 */
export function getLibStatus(data: { enterpriseId: number | null }) {
    return post<LibStatusItem[]>({
        url: '/assistant/lib/stats',
        data
    })
}

/**
 * 基本知识库列表  - 获取通用知识库列表
 */
export function getGenericKnowledgeBase() {
    return post<GenericKnowledgeBaseItem[]>({
        url: '/assistant/lib/listGenericKnowledgeBase'
    })
}

/**
 * 知识库权限 - 就是当前用户在当前空间下有哪些知识库的权限 于 src/api 下的 getWorkspaces 方法一致
 */
export function getWorkspaces() {
    return post<EnterpriseListModel>({
        url: '/assistant/enterprise/getWorkspace',
    })
}


/**
 * 树形列表 获取知识库结构 工作空间 -> 知识库 -> 文件夹 -> 文件
 */
export function getKnowlegeSelectorTree(data: KnowlegeSelectorParams) {
    return post<KnowlegeSelectorModel>({
        url: '/assistant/lib/getSelector',
        data
    })
}


/**
 * 根据知识库id 查找文件夹列表
 */
export function getFolderListByLibId(data: { libId: number }) {
    return get<{ dirId: number, dirName: string, fileCount: number }[]>({
        url: '/assistant/lib/dir/listDir',
        data
    })
}

/**
 * 根据知识库id获取path
 */
export function getLibPath(id: number | string) {
    return get<LibPathItem[]>({
        url: '/assistant/lib/paths/' + id,
    })
}

/**
 * 根据知识库文件夹id获取path
 */
export function getDirPath(id: number | string) {
    return get<LibPathItem[]>({
        url: '/assistant/lib/dir/paths/' + id,
    })
}

/**
 * 根据知识库文件id获取path
 */
export function getFilePath(id: number | string) {
    return get<LibPathItem[]>({
        url: '/assistant/lib/file/paths/' + id,
    })
}